import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import axios from 'axios'
const api = '/api/'

export const ListStudentFee = createAsyncThunk(
  'school-student-fee-list',
  async (params: {}, thunkAPI) => {
    try {
      const response = await axios.get(`${api}school-student-fee/list`, params)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const StudentFeeSummary = createAsyncThunk('fees-summary', async (_, thunkAPI) => {
  try {
    const response = await axios.get(`${api}school-student-fee/fees-summary`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Get StudentList
export const ListStudent = createAsyncThunk('school-student-list', async (_, thunkAPI) => {
  try {
    const response = await axios.get(`${api}school-student-fee/get-students`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const getStudentFeeDetails = createAsyncThunk(
  'school-student-fee-details',
  async (student_id: any, thunkAPI) => {
    try {
      const response = await axios.get(`${api}school-student-fee/student-details/` + student_id)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data)
      }
    }
  }
)

export const studentFeeStore = createAsyncThunk(
  'school-student-fee-store',
  async (companyData: any, thunkAPI) => {
    try {
      const {data} = await axios.post(`${api}school-student-fee/store`, companyData)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors)
    }
  }
)

export const editStudentFee = createAsyncThunk(
  'school-student-fee-edit',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`/api/school-student-fee/edit/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const studentFees = createAsyncThunk('school-student-fees', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`${api}school-student-fee/student-fees/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const printStudentFee = createAsyncThunk(
  'student-fee-print',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`${api}school-student-fee/print/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const deleteStudentFee = createAsyncThunk(
  'student-fee-delete',
  async (id: string, thunkAPI) => {
    try {
      await axios.get(`${api}school-student-fee/delete/${id}`)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

type StudentFeeState = {
  errors: any
}

const initialState: StudentFeeState = {
  errors: '',
}

export const studentFeeSlice = createSlice({
  name: 'student-fee',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {},
})

export const {reset} = studentFeeSlice.actions
export default studentFeeSlice.reducer
